import MobileLayout from './AvatarInputLayout.mobile';
import { isReactNative } from 'ui-builder';

// eslint-disable-next-line @typescript-eslint/no-var-requires
export default isReactNative() ? MobileLayout : require('./AvatarInputLayout.web').default;
